import { cx } from "./util";

/** Large number + plain label + optional source. Only sourced figures or product facts. */
export default function Stat({ value, unit, label, source, className }) {
  return (
    <div className={cx("gd-stat", className)}>
      <div className="gd-stat-val">{value}{unit && <em>{unit}</em>}</div>
      <div className="gd-stat-label">{label}</div>
      {source && <div className="gd-stat-src">src: {source}</div>}
    </div>
  );
}
